import { makeStyles } from "@material-ui/styles"

const styles = makeStyles(theme => ({
  root: {}
}))

export default styles



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationText/CommunicationTextAccordion/styles.js